import React from 'react';
import { Header } from '@/components';
import { ConfirmationCodeHero } from '@/features/user/components/confirmation';

const ConfirmationCodePage: React.FC = () => {
  return (
    <div className="bg-black min-h-screen">
      <Header />
      <ConfirmationCodeHero />
    </div>
  );
};

export default ConfirmationCodePage;
